import { useMemo } from 'react'
import gql from 'graphql-tag'
import { useQuery } from '@apollo/client'

export const FUEL_GRADES_QUERY = gql`
  query fuelGrades($stationIds: [ID!]!) {
    fuelGrades(stationIds: $stationIds) {
      id
      shortTitle
      title
      position
      primary
    }
  }
`

const useFuelGrades = (stationAndGroupIds = [], stationData = null, isEdgeDataPro = false, groups = []) => {
  const stationIds = []

  // We need to filter through the stationAndGroupIds and for each ID that is a groupId (doesn't contain 'stat-'),
  // we need to return the stationIds for that group
  stationAndGroupIds.forEach(stationOrGroupId => {
    if(stationOrGroupId.startsWith("stat-")) {
      stationIds.push(stationOrGroupId)
    } else {
      const allChildGroups = groups.flatMap((groupSet) => groupSet.childGroups)
      const matchedGroup = allChildGroups.find((group) => group.id === stationOrGroupId)
      
      if(matchedGroup && matchedGroup.stationGuids) {
        matchedGroup.stationGuids.forEach(stationId => {
          if (!stationIds.includes(stationId)) stationIds.push(stationId)
        })
      }
    }
  })

  const { loading, data, error } = useQuery(FUEL_GRADES_QUERY, {
    variables: {
      stationIds
    },
    skip: !stationIds?.length || !!stationData,
  })

  const sortedFuelGrades = useMemo(
    () => data?.fuelGrades && [...data.fuelGrades].sort((a, b) => a.position - b.position),
    [data?.fuelGrades]
  )

  if (stationData) {
    return {
      fuelGradesLoading: false,
      fuelGrades: stationData.fuelGrades.map(fg => fg.fuelGrade),
    }
  }

  if (isEdgeDataPro) {
    const edgeDataProFuelGrades = {
      fuelGrades: [
        { id: "4", title: "Diesel Super" },
        { id: "3", title: "Unleaded Super" },
        { id: "2", title: "Diesel" },
        { id: "1", title: "Unleaded" }
      ]
    };
    return {
      fuelGradesLoading: false,
      fuelGrades: edgeDataProFuelGrades.fuelGrades,
    };
  }

  return {
    fuelGradesLoading: loading,
    fuelGrades: sortedFuelGrades,
    fuelGradesError: error,
  }
}

export { useFuelGrades }
